import { Observable, from, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ManageIdbService } from './manage-idb.service';
import { IdbOtCatalogName, IdbOtCatalogTypeMap } from './idb-catalog-name.enum';

/**
 * Wraps ManageIdbService.selectOtCatalog in an Observable with built-in error handling.
 * On IDB failure, emits null so callers can fall through to backend.
 */
export function fromIdbOtCatalog<K extends IdbOtCatalogName>(
  idb: ManageIdbService,
  catalogName: K,
): Observable<IdbOtCatalogTypeMap[K] | null> {
  return from(idb.selectOtCatalog(catalogName)).pipe(catchError(() => of(null)));
}
